import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import NavPills from "../../../components/NavPills/NavPills.jsx";

import pillsStyle from "../../../assets/jss/material-kit-pro-react/views/componentsSections/pillsStyle.jsx";

import { prizesList, corporateValuesList } from "../assets";

class SectionPills extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <div id="navigation-pills">
            <GridContainer>
              <GridItem xs={12} sm={12} md={8} lg={8}>
                <h3>Nuestros Logros</h3>
                <NavPills
                  horizontal={{
                    tabsGrid: { xs: 12, sm: 4, md: 5 },
                    contentGrid: { xs: 12, sm: 8, md: 7 }
                  }}
                  color="success"
                  tabs={prizesList.map(prize => {
                    return {
                      tabButton: prize.title,
                      tabContent: (
                        <span>
                          <p>{prize.description} {prize.seeMore && <a href={prize.seeMore} target="_blank">Ver más...</a>}</p>
                          <img
                            src={prize.image}
                            width="100%"
                            alt={prize.title}
                          />
                        </span>
                      )
                    };
                  })}
                />
              </GridItem>

              <GridItem xs={12} sm={12} md={4} lg={4}>
                <h3>Valores de la Empresa</h3>
                <NavPills
                  color="primary"
                  tabs={corporateValuesList.map(corporateValue => {
                    return {
                      tabButton: corporateValue.title,
                      tabIcon: corporateValue.icon,
                      tabContent: (
                        <span>
                          <p>{corporateValue.description}</p>
                        </span>
                      )
                    };
                  })}
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(pillsStyle)(SectionPills);



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/Sections/SectionPills.jsx